export const msalConfig = {
    auth: {
        clientId: "289c3ab4-125e-4f46-8bb5-bc25f131f621", // Application (client) ID
        authority: "https://login.microsoftonline.com/40bbb465-7473-4695-ad2c-d8e097e8d88a", // Directory (tenant) ID
        redirectUri: window.location.origin + "/admin",
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["User.Read"]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
